import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	BillingCycleChangePreviewResult,
	BillingCycleChangeRequest,
} from '../../../admin/components/tools/UpgradeWizard/types';

export function usePreviewBillingCycleChangeMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: BillingCycleChangeRequest) => {
			return userSession.webServiceHelper.callAsync<BillingCycleChangePreviewResult>(
				'admin/BillingUtilities/PreviewBillingCycleChange',
				'POST',
				request
			);
		},
	});
}
